Vue.component('set-goal', {

  props: ['team', 'available_channels'],

  data() {
    return {
      form: new SparkForm({
          source: '',
          newOverallAverage: '',
          atDate: ''
      }),
      channelStats: null,
      goalOptions: null,
      scenarios: [],
      selectedIndex: null,
      is_expanded: false,
      from_original_params: null,
      errorMessage: null,
      warningMessage: null,
      working: false,
    }
  },

  computed: {
    filled() {
      return this.form.source != '' && 
        this.form.newOverallAverage != '' && this.form.atDate != ''
    },
    isChannelFilled() {
      return this.form.source != ''
    },
    isGoalFilled() {
      return this.form.newOverallAverage != ''
    },
    isDueDateFilled() {
      return this.form.atDate != ''
    },
    channelOutOf() {
      return this.form.source == '' ? 5 : this.getRatingType(this.form.source)
    },
    placeholderValue() {
      return (0.9 * this.channelOutOf).toFixed(1)
    },
    channelImage() {
      return this.getImageSource(this.form.source)
    },
    channelAverage() {
      return this.channelStats.estimated_displayed_rating.toFixed(1)
    },
    channelReviews() {
      return this.channelStats.no_of_reviews
    },
    channelStep() {
      if (this.form.source == 'trip_advisor') return 0.5
      else return 0.1
    },
    teamId() {
      return this.team ? this.team.id : Spark.state.currentTeam.id
    },
    finished() {
      return this.scenarios.length > 0
    }
  },

  mounted() {

    this.$eventHub.$on('setGoalDueDate', date => this.setGoalDate(date))
    this.$eventHub.$on('setAddGoalSelectedSource', source => this.setSource(source))

  },

  methods: {

    setGoalDate(date) {
      this.trackFilledEvent('date', date)
      this.form.atDate = date
      this.processChange()
    },

    setSource(source = false) {
      if (source) this.form.source = source

      this.trackFilledEvent('source', this.form.source)

      this.getChannelStats()
    },

    trackFilledEvent(field, value) {
      analytics.track("Filled Add Goal Field", {
        field_name: field,
        field_value: value
      })
    },

    expand() {
      this.is_expanded = ! this.is_expanded
    },

    processChange() {
      if (this.isChannelFilled && ( this.isGoalFilled || this.isDueDateFilled ) )  {
        this.checkGoal()
      }
    },

    closeAddGoal() {
      this.$parent.$emit('closeAddGoal', true)
    },

    saveGoal() {
      if(this.selectedIndex == null) {
        this.selectedIndex = 0
      }


      let payload = Object.assign({}, this.scenarios[this.selectedIndex])
      payload.is_active = undefined;
      
      analytics.track("Saved Goal", {
        team_id: this.teamId,
        form: this.form
      })

      this.working = true

      axios.post('/api/goals/' + this.teamId, payload)
      .then(response => {
        // Force parent / sibling elements to update
        this.$eventHub.$emit('goalsUpdated', true)
        swal('Congrats!', 'A new goal has been added for ' + this.sourceLabelFromSlug(this.form.source), 'success')
        this.clearForm()
        this.$parent.$emit('closeAddGoal', true)
      }).catch(error => {
        //this.errorMessage = error
        console.log(error)
        this.clearMessages()
      })

    },

    clearForm() {
      this.form.source = ''
      this.form.newOverallAverage = ''
      this.form.atDate = ''
      this.scenarios = []
      this.selectedIndex = null
      this.channelStats = null
      this.clearMessages()
    },

    clearMessages() {
      this.working = false
      this.errorMessage = null
      this.warningMessage = null
    },

    getChannelStats() {
      var source = this.form.source
      this.clearForm()
      this.form.source = source
      this.working = true
      axios.get('/api/goals-explore/' + this.teamId + '/current-status?source=' + this.form.source)
      .then(response => {
        this.channelStats = response.data
        this.clearMessages()
      }).catch(error => {
        this.clearMessages()
        console.log(error)
      })

      this.processChange()
    },

    checkGoal() {
      var params = {
        source: this.form.source,
        atDate: this.form.atDate,
        newOverallAverage: this.form.newOverallAverage,
      }

      this.working = true
      this.selectedIndex = null

      axios.get('/api/goals-explore/' + this.teamId + '/rating', { params: params })
      .then((response) => {
        this.clearMessages()
        if('_error_' in response.data) {
          console.log(response);
          this.errorMessage = response.data._error_.message
        }
        else {
          this.scenarios = response.data.goals

          if (this.scenarios.length == 1) this.selectedIndex = 0

          this.from_original_params = response.data.from_original_params
          this.warningMessage = ( response.data.from_original_params ? '' : 
            ( response.data.goals.length > 0 ? 
              'The shown suggestion(s) are approximations to what you asked for.' :
              'Sorry, but we could not find any suggestion for these parameters.')
            );
        }
      }).catch(error => {
        this.clearMessages()
        console.log(error)
      })

    },

    achieveCleanDate(scenario) {

      return moment(scenario.achieve_by_date).format("D MMM YYYY")


    },

    checkGoalInput(event) {
      
      if (this.form.newOverallAverage < 0) this.form.newOverallAverage = 0

      this.form.newOverallAverage = Math.round(parseFloat(this.form.newOverallAverage) * 10) / 10


      if (this.channelStep != 0.1) {
        while (
          Math.round(this.form.newOverallAverage % this.channelStep * 10) != 0
        ) {
          this.form.newOverallAverage = Math.round((this.form.newOverallAverage + 0.1) * 10) / 10
        }
      }

      // Don't allow more than 5/10 depending on the source
      if (this.form.newOverallAverage > this.channelOutOf) {
        this.form.newOverallAverage = parseFloat(this.channelOutOf)
      }

      this.form.newOverallAverage = this.form.newOverallAverage.toFixed(1).replace('.0', '')

      this.trackFilledEvent('goal', this.form.newOverallAverage)
      this.processChange()

    }
  }

})